// /!\ WARNING /!\ There are optionalFilter property on Configure component
// Check there aren't this property set before use this component
import { arrayOf, string } from 'prop-types';
import { createConnector } from 'react-instantsearch-core';

const connectOptionalFilters = createConnector({
    displayName: 'OptionalFilters',
    propTypes: {
        defaultRefinement: arrayOf(string),
    },

    getProvidedProps() {
        return {};
    },
    refine(props, searchState, nextRefinement) {
        return {
            ...searchState,
            optionalFilters: nextRefinement,
        };
    },
    getSearchParameters(searchParameters, props, searchState) {
        const nextValue =
            searchState.optionalFilters || props.defaultRefinement;
        return searchParameters.setQueryParameter('optionalFilters', nextValue);
    },
    cleanUp(props, searchState) {
        const { optionalFilters, ...nextSearchState } = searchState;

        return nextSearchState;
    },
});

export default connectOptionalFilters(() => null);
